// extracted by mini-css-extract-plugin
module.exports =  {"key-value":"KeyValue-module__key-value___mJSUj"};